import React from 'react';

export default function YouTubePlayer({ url, title }) {
  const convertToEmbedUrl = (url) => {
    if (!url) return '';

    // حالت watch?v=
    if (url.includes('watch?v=')) {
      return url.replace('watch?v=', 'embed/');
    }

    // حالت youtu.be
    if (url.includes('youtu.be/')) {
      const id = url.split('youtu.be/')[1].split('?')[0];
      return `https://www.youtube.com/embed/${id}`;
    }

    // حالت embed آماده
    if (url.includes('/embed/')) {
      return url;
    }

    return url;
  };

  return (
    <div className="ratio ratio-16x9">
      <iframe
        src={convertToEmbedUrl(url)}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        loading="lazy"
        frameBorder="0"
        style={{ width: '100%', height: '100%', border: 0 }}
      />
    </div>
  );
}

